import { ExerciseType } from '@/stores/store.types';
import {
  getFullExerciseName,
  ExerciseType as modalitiesType,
} from './exerciseNames';

export const getPlaybackRate = (
  exerciseTypes: ExerciseType[],
  modalities: modalitiesType,
  setType: 'sentenceset' | 'wordset' | 'textset',
) => {
  return exerciseTypes.find(
    ({ name }) => name === getFullExerciseName(modalities, setType),
  )?.playbackRate;
};
